import React, { Component } from 'react'
import Link from 'gatsby-link'
import { CSSTransition } from 'react-transition-group'

import IconTriangle from '../../images/svg/triangle.svg'
import IconTriangleHover from '../../images/svg/triangle-orange.svg'

import Menu from '../menu'
import './style.sass'

export default class Nav extends Component {
  state = { isMenuVisible: false, isTriangleHover: false }

  toggleMenu = () => {
    this.setState({ isMenuVisible: !this.state.isMenuVisible }, () => {
      if (this.state.isMenuVisible) {
        return (document.body.style.overflow = 'hidden')
      }

      document.body.style.overflow = 'auto'
    })
  }

  render() {
    const triangleImageSrc = this.state.isTriangleHover
      ? IconTriangleHover
      : IconTriangle

    const { visible, locale } = this.props
    const linkPrefix = locale === 'it' ? '' : '/en'

    return (
      <div>
        <div className={`Nav ${visible ? 'Nav--visible' : ''}`}>
          <button
            className={
              'hamburger hamburger--slider ' +
              (this.state.isMenuVisible ? 'is-active' : '')
            }
            type="button"
            onClick={this.toggleMenu}
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>

          <Link
            to={`${linkPrefix}/`}
            onMouseEnter={() => this.setState({ isTriangleHover: true })}
            onMouseLeave={() => this.setState({ isTriangleHover: false })}
          >
            <img
              className="Nav__Triangle"
              src={triangleImageSrc}
              alt="Click to go to home page"
            />
          </Link>

          {/* Elemento vuoto per far tornare la distribuzione dello 
        spazio degli elementi con Flex */}
          <div style={{ width: '50px' }} />
        </div>

        <CSSTransition
          in={this.state.isMenuVisible}
          timeout={200}
          classNames="Nav__MenuContainer"
          unmountOnExit
        >
          <Menu locale={locale} onLinkClick={this.toggleMenu} />
        </CSSTransition>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/nav/index.js